import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const formContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
});

export const dateRangeContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s12,
});
